import _ from '@lodash';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { IconButton, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormDateTimeField from 'modules/ui/editform/fields/EditFormDateTimeField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { sub } from 'date-fns';
import LabMeasurementReaderService from 'app/admin/labMeasurementReader/service/LabMeasurementReaderService';

export const summaryTypes = ['Total', 'Average', 'Minimum', 'Maximum'];
export const summaryDurationUnits = [
	{ label: 'Day', value: 'Day' },
	{ label: 'Hour', value: 'Hour' }
];

function LabMeasurementReaderQuery(props) {
	const labMeasurementReaderName = props.labMeasurementReaderName || null;
	const { t } = useTranslation(['common', 'validation']);
	const [loading, setLoading] = useState(false);
	const [items, setItems] = useState([]);

	useEffect(() => {
		if (!items.length)
			LabMeasurementReaderService.getListSelection().then(resolve => { setItems(resolve) }).catch(e => { console.error(e) });
	}, []);

	useEffect(() => {
		setLoading(!(items.length > 0));
	}, [items]);

	const schema = yup.object().shape({
		name: yup.string().nullable().required(t('validation:FIELD_REQUIRED')),
		start_date_time: yup.date().nullable().required(t('validation:FIELD_REQUIRED')),
		end_date_time: yup.date().nullable().required(t('validation:FIELD_REQUIRED')),
		summary_duration: yup.number().nullable().required(t('validation:FIELD_REQUIRED')),
		summary_duration_unit: yup.string().nullable().required(t('validation:FIELD_REQUIRED')),
		summary_type: yup.string().nullable().required(t('validation:FIELD_REQUIRED'))
	});

	const methods = useForm({
		defaultValues: {
			name: labMeasurementReaderName,
			start_date_time: sub(new Date(), { weeks: 1 }),
			end_date_time: new Date(),
			summary_duration: 1,
			summary_duration_unit: 'Day',
			summary_type: 'Average'
		},
		mode: 'onChange',
		resolver: yupResolver(schema)
	});

	const getItem = (id) => {
		if (id && items) for (let i = 0; i < items.length; i += 1) if (items[i].id + "" === id + "") return items[i];
		return null;
	};

	const handleSave = dto => {
		setLoading(true);
		props.onResult(null);

		const item = getItem(dto.name);

		LabMeasurementReaderService
			.get(item.id, { ...dto, name: item.name })
			.then(resolve => { props.onResult(resolve); console.log(resolve); setLoading(false); })
			.catch(e => { props.onResult(null); setLoading(false); });
	};

	return (
		<FormProvider {...methods}>
			<div className="flex flex-row">
				<div className="flex flex-1 flex-col mr-12">
					<div className="flex flex-row">
						<Controller
							control={methods.control}
							name="name"
							render={({ field, fieldState }) => (
								<EditFormSelectField
									field={field}
									fieldState={fieldState}
									config={{ topic: 'labMeasurementReader' }}
									fieldConfig={{
										className: 'mr-8',
										key: 'name',
										// type: 'enum',
										readOnly: labMeasurementReaderName != null,
										items: () => LabMeasurementReaderService.getListSelection()
									}}
								/>
							)}
						/>
						<Controller
							control={methods.control}
							name="start_date_time"
							render={({ field, fieldState }) => (
								<EditFormDateTimeField
									field={field}
									fieldState={fieldState}
									config={{ topic: 'labMeasurementReader' }}
									fieldConfig={{
										className: 'ml-8 mr-8',
										key: 'start_date_time'
									}}
								/>
							)}
						/>
						<Controller
							control={methods.control}
							name="end_date_time"
							render={({ field, fieldState }) => (
								<EditFormDateTimeField
									field={field}
									fieldState={fieldState}
									config={{ topic: 'labMeasurementReader' }}
									fieldConfig={{
										className: 'ml-8',
										key: 'end_date_time'
									}}
								/>
							)}
						/>
					</div>
					{/* <div className="flex flex-row">
						<Controller
							control={methods.control}
							name="summary_type"
							render={({ field, fieldState }) => (
								<EditFormSelectField
									field={field}
									fieldState={fieldState}
									config={{ topic: 'labMeasurementReader' }}
									fieldConfig={{
										className: 'mr-8',
										key: 'summary_type',
										type: 'enum',
										items: summaryTypes.map(type => {
											return { label: type, value: type };
										})
									}}
								/>
							)}
						/>
						<Controller
							control={methods.control}
							name="summary_duration"
							render={({ field, fieldState }) => (
								<EditFormTextField
									field={field}
									fieldState={fieldState}
									config={{ topic: 'labMeasurementReader' }}
									fieldConfig={{
										className: 'ml-8 mr-8',
										key: 'summary_duration',
										type: 'number'
									}}
								/>
							)}
						/>
						<Controller
							control={methods.control}
							name="summary_duration_unit"
							render={({ field, fieldState }) => (
								<EditFormSelectField
									field={field}
									fieldState={fieldState}
									config={{ topic: 'labMeasurementReader' }}
									fieldConfig={{
										className: 'ml-8',
										key: 'summary_duration_unit',
										type: 'enum',
										items: summaryDurationUnits
									}}
								/>
							)}
						/>
					</div> */}
				</div>
				<div className="mt-12">
					<IconButton onClick={() => methods.handleSubmit(handleSave)()} disabled={loading}>
						<Icon>search</Icon>
					</IconButton>
				</div>
			</div>
		</FormProvider>
	);
}

export default LabMeasurementReaderQuery;